import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
import InputText from 'realize/components/input/input_text';
import ButtonGroup from 'realize/components/button/button_group.jsx';
import { connectToStore } from 'reflux/decorators/connect_to_store.js';
import LecomLabel from 'form/components/label/label';
import { DocumentActions, DocumentStore } from '../../reflux/document_store';
import { GridFormActions } from '../../../grid_form/reflux/grid_form_store';
import { ProcessAPI, FormAPI } from 'lecom-api';
import TemplatePermissionType from '../../constants/template_permission_type';
import DocumentHelper from '../../helpers/document_helper';
import DocumentSubmitDataContainers from '../../constants/document_submit_data_containers';
import { FormEvents } from '../../../form/events/form_event_handler';

@connectToStore(DocumentStore, { storeIdProp: 'name', propsForwardToTarget: ['value', 'disabled', 'helpText', 'readOnly', 'required', 'label', 'visible'] })
@mixin.decorate(window.CssClassMixin)

export default class InputDocument extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		templateId: PropTypes.number,
		canCreate: PropTypes.bool,
		canImport: PropTypes.bool,
		canAttach: PropTypes.bool,
		createButton: PropTypes.object,
		importButton: PropTypes.object,
		attachButton: PropTypes.object,
		manageButton: PropTypes.object,
		detachButton: PropTypes.object,
		downloadButton: PropTypes.object,
		formFieldMappings: PropTypes.array,
		digitalSignatureButton: PropTypes.object,
		previewButton: PropTypes.object,
	};

	static defaultProps = {
		id: '',
		name: '',
		templateId: '',
		canCreate: true,
		canImport: true,
		canAttach: true,
		label: Realize.i18n.t('template.defaultLabel'),
		createButton: {},
		importButton: {},
		attachButton: {},
		downloadButton: {},
		formFieldMappings: [],
		previewButton: {}
	};

	constructor(props) {
		super(props);
		this.onClickDocumentNameInput = this.onClickDocumentNameInput.bind(this);

		this.inputDocId = this.props.id;
	}

	componentDidMount() {
		if (this.props.value) {
			const fileUUID = this.props.value.split(":")[1];
			DocumentActions.loadDocument(this.props.id, fileUUID);
		}

		setTimeout(() => {
			this.valueInputDocument()
		}, 100);

		window.addEventListener("message", this.receiveActions.bind(this));
	}

	componentDidUpdate() {
		setTimeout(() => {
			this.valueInputDocument()
			this.focusBotaoAssinador()
		}, 200);
	}

	componentWillUnmount() {
		window.removeEventListener("message", this.receiveActions.bind(this));
	}

	receiveActions(e) {
		const reveiveData = e.data;

		if (reveiveData.event === 'DIGITAL_SIGNATURE') {
			if (window.gridDataSign && window.gridDataSign.name === this.props.name) {
				GridFormActions.updateDataRowSign(window.gridDataSign.gridId, window.gridDataSign.name, reveiveData.fileUniqueId);
			}
			else if (window.currentDocumentIdSign === this.props.id) {
				DocumentActions.setFileUniqueIdInDocument(this.props.id, reveiveData.fileUniqueId);
			}
		}
	}

	valueInputDocument() {
		$(`#input__${this.props.id} input`).val() === '' ? $(`#input__${this.props.id} input`).attr('tabindex', -1) : $(`#input__${this.props.id} input`).attr('tabindex', 0);
	}

	focusBotaoAssinador() {
		let botaoAssinador = $('.document-field .btnAssinatura');

		if(botaoAssinador.length > 0){
			botaoAssinador.attr('tabindex', '0');

			botaoAssinador.keypress((e) => {
				e.which === 13 && botaoAssinador[0].click();
			});
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.props.value)
			DocumentActions.setValueInDocument(nextProps.id, nextProps.value);
	}

	get document() {
		return this.props.document;
	}

	get template() {
		return this.props.template;
	}

	get waitingForAction() {
		return this.props.waitingForAction;
	}

	get hasAnyPermissionOnTemplate() {
		return this.template && !!this.template.permissionType && this.template.permissionType !== TemplatePermissionType.NO_ACCESS;
	}

	get creationIsEnabled() {
		return (this.props.canCreate && this.hasAnyPermissionOnTemplate) && !this.template.pdfSigned;
	}

	getIsMobile() {
		const processAPI = ProcessAPI.currentProcess();
		const isMobile = processAPI.isMobile();

		return isMobile;
	}

	getClassName() {
		return this.props.selected ? " cursor-pointer" : "";
	}

	getValue() {
		return this.props.value;
	}

	isDisabled() {
		return this.props.disabled || this.waitingForAction || this.waitingForAction === undefined;
	}

	getLicenseEcm() {
		const processAPI = ProcessAPI.currentProcess();
		const isECMLicenseFull = processAPI.isECMLicenseFull();

		return isECMLicenseFull;
	}

	getSignPermission() {
		const processAPI = ProcessAPI.currentProcess();
		const signPermission = processAPI.signPermission();

		return !!signPermission;
	}

	buttonLicenseEcm() {
		return this.getLicenseEcm() ? 'btn-license-full' : 'btn-license-basic';
	}

	buildSelectDocumentButtonGroupProps() {
		let buttonGroupProps = [];

		if (this.props.readOnly) {
			return buttonGroupProps;
		}

		if (this.creationIsEnabled) {
			buttonGroupProps.push(this.buildCreateButtonProps());
		}

		if (this.props.canImport) {
			buttonGroupProps.push(this.buildImportButtonProps());
		}

		if (!this.getIsMobile() && this.props.canAttach && this.hasAnyPermissionOnTemplate) {
			buttonGroupProps.push(this.buildAttachButtonProps());
		}

		return buttonGroupProps;
	}

	buildManageDocumentButtonGroupProps() {
		const currentProcess = ProcessAPI.currentProcess();

		if (currentProcess.isPublic()) {
			return this.props.readOnly
				? [this.buildPreviewButtonProps(), this.buildDownloadButtonProps()]
				: [this.buildPreviewButtonProps(), this.buildDetachButtonProps()];
		} else {
			if (this.props.disabled === true && this.props.template.pdfSigned === true) {
				return [this.buildPreviewButtonProps(), this.buildDownloadButtonProps(), this.buildSignatureButtonProps()];
			} else if (this.props.readOnly === true && this.props.template.pdfSigned === true) {
				return [this.buildPreviewButtonProps(), this.buildDownloadButtonProps()];
			} else if (this.props.template.pdfSigned === true) {
				return [this.buildPreviewButtonProps(), this.buildManageButtonProps(), this.buildDetachButtonProps(), this.buildSignatureButtonProps()];
			} else {
				return this.props.readOnly || this.props.disabled
					? [this.buildPreviewButtonProps(), this.buildDownloadButtonProps()]
					: [this.buildPreviewButtonProps(), this.buildManageButtonProps(), this.buildDetachButtonProps()];
			}
		}
	}

	buildCreateButtonProps() {
		return Object.assign({
			element: 'a',
			icon: 'insert_drive_file',
			style: 'cancel',
			role: "button",
			tooltipText: Realize.i18n.t('template.actions.create'),
			disabled: this.isDisabled(),
			className: 'template-create-document button-custom',
			role: 'button',
			'aria-label': (this.props.value === '') ? (`${this.props.label || this.props.name} - ${Realize.i18n.t('general.new_document')}`) : (`${this.props.label || this.props.name} - ${Realize.i18n.t('general.document_create').replace('@', this.props.value)}`)
		}, this.props.createButton, {
			onClick: this.openModal.bind(this, 'openCreateDocumentModal') //DocumentActions.openCreateDocumentModal.bind(this, this.props.id)
		});
	}

	buildImportButtonProps() {
		return Object.assign({
			element: 'a',
			icon: 'attach_file',
			style: 'cancel',
			role: "button",
			tooltipText: Realize.i18n.t('template.actions.import'),
			disabled: this.isDisabled(),
			className: 'template-import-document button-custom',
			'aria-label': (this.props.value === '') ? (`${this.props.label || this.props.name} - ${Realize.i18n.t('general.not_attached_document')}`) : (`${this.props.label || this.props.name} - ${Realize.i18n.t('general.attach_document_form').replace('@', this.props.value)}`),
		}, this.props.importButton, {
			onClick: () => {
				$(`#container-import-file-input__${this.props.id} .import-file-input`).trigger("click");
			}
		});
	}

	buildAttachButtonProps() {
		return Object.assign({
			element: 'a',
			icon: 'find_in_page',
			style: 'cancel',
			role: "button",
			className: 'button-custom',
			tooltipText: Realize.i18n.t('template.actions.attach'),
			disabled: this.isDisabled(),
			'aria-label': (this.props.value === '') ? (`${this.props.label || this.props.name} -  ${Realize.i18n.t('general.attach_document')}`) : (`${this.props.label || this.props.name} -  ${Realize.i18n.t('general.attach_document_form').replace('@', this.props.value)}`)
		}, this.props.attachButton, {
			onClick: this.openModal.bind(this, 'openAttachDocumentModal')
		});
	}

	buildManageButtonProps() {
		if (!this.getLicenseEcm()) {
			return Object.assign({
				className: this.buttonLicenseEcm(),
				element: 'a',
				icon: 'edit',
				className: 'button-custom',
				style: 'cancel',
				role: 'button',
				tooltipText: Realize.i18n.t('template.messages.licenseECM'),
				'aria-label': Realize.i18n.t('general.button.edit'),
				disabled: this.isDisabled()
			});
		} else {
			return Object.assign({
				element: 'a',
				role: "button",
				icon: 'edit',
				style: 'cancel',
				tooltipText: Realize.i18n.t('template.actions.manage'),
				disabled: this.isDisabled(),
				className: 'template-edit-document button-custom',
				'aria-label': Realize.i18n.t('general.button.edit'),
			}, this.props.manageButton, {
				onClick: this.openModal.bind(this, 'openManageDocumentModal') //DocumentActions.openManageDocumentModal.bind(this, this.props.id)
			});
		}
	}

	buildDetachButtonProps() {
		return Object.assign({
			element: 'a',
			role: "button",
			icon: 'delete',
			style: 'cancel',
			tooltipText: Realize.i18n.t('template.actions.detach'),
			disabled: this.isDisabled(),
			className: 'template-desvincular-documento button-custom',
			'aria-label': Realize.i18n.t('general.button.delete'),
		}, this.props.detachButton, {
			onClick: this.openModal.bind(this, 'openDetachDocumentModal') //DocumentActions.openDetachDocumentModal.bind(this, this.props.id)
		});
	}

	buildDownloadButtonProps() {
		return Object.assign({
			element: 'a',
			role: "button",
			icon: 'cloud_download',
			style: 'cancel',
			className: 'button-custom',
			tooltipText: Realize.i18n.t('template.actions.downloadDocument'),
			'aria-label': Realize.i18n.t('general.button.download'),
		}, this.props.downloadButton, {
			onClick: () => {
				const { document } = this.props;
				const inputDocumentValue = {
					fileName: document.fileName || '',
					fileUUID: document.fileUUID || ''
				};
				DocumentActions.downloadDocumentFile(this.props.id, inputDocumentValue);
			}
		});
	}

	buildSignatureButtonProps(){
		if (this.props.template !== undefined && this.props.template.pdfSigned === true && this.getSignPermission()) {
			return Object.assign({
				element: 'a',
				icon: 'certificate',
				style: 'cancel',
				tooltipText: Realize.i18n.t('template.actions.digitalSignature'),
			}, this.props.digitalSignatureButton, {
				onClick: () => {
					const { document } = this.props;
					const inputDocumentValue = {
						fileName: document.fileName || '',
						fileUUID: document.fileUUID || ''
					};

					window.gridDataSign = null;
					window.currentDocumentIdSign = this.props.id;

					DocumentActions.openDigitalSignature(this.props.id, inputDocumentValue);
				}
			});
		}
	}

	buildPreviewButtonProps() {
		let classNames = 'button-custom';
		let tooltipText = Realize.i18n.t('template.actions.previewDocument');

		return Object.assign({
			element: 'a',
			role: "button",
			icon: 'visibility',
			style: 'cancel',
			className: classNames,
			tooltipText: tooltipText,
			'aria-label': tooltipText,
		}, this.props.previewButton, {
			onClick: () => {
				const { document } = this.props;
				const inputDocumentValue = {
					fileName: document.fileName || '',
					fileUUID: document.fileUUID || ''
				};

				DocumentActions.previewDocumentFile(inputDocumentValue.fileUUID);
			}
		});
	}

	onClickDocumentNameInput() {
		if (this.props.selected) {
			const { document } = this.props;
			const inputDocumentValue = {
				fileName: document.fileName || '',
				fileUUID: document.fileUUID || ''
			};
			DocumentActions.downloadDocumentFile(this.props.id, inputDocumentValue);
		}
	}

	openModal(type) {
		if (!sessionStorage.getItem('click')) {
			sessionStorage.setItem('click', true);
			setTimeout(() => {
				DocumentActions[type].bind(this, this.props.id)();
				sessionStorage.removeItem('click');
			}, 500);
		}
	}

	clickDropFileInput(e) {
		$(`#container-import-file-input__${this.props.id} .import-file-input`).trigger("click");
	}

	dragEnterFileInput(e) {
		e.preventDefault();
  		e.stopPropagation();

		$(e.target).addClass('highlight');
	}

	dragOverFileInput(e) {
		e.preventDefault();
  		e.stopPropagation();

		$(e.target).addClass('highlight');
	}

	dragLeaveFileInput(e) {
		e.preventDefault();
  		e.stopPropagation();

		$(e.target).removeClass('highlight');
	}

	dropFileInput(e) {
		e.preventDefault();
  		e.stopPropagation();

		$(e.target).removeClass('highlight');

		const file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length ? e.dataTransfer.files[0] : null;
		this.changeImportFileInput(e, file);
	}

	changeImportFileInput(e, file) {
		const fileFieldKey = `${DocumentSubmitDataContainers.IMPORT}.file`;
		const selectedFile = file || e.target.files[0];
		const formApi = FormAPI.form(this.props.formId);
		const field = this.props.gridFormParent ? formApi.fields(this.props.gridFormParent).fields(this.props.id) : formApi.fields(this.props.id);
		const splitSelectedFile = selectedFile.name.split('.');
		const lengthSplit = splitSelectedFile.length -1;
		const typeFile = splitSelectedFile[lengthSplit];
		const allowedFileTypes = this.props.template.allowedFileTypes;
		const maxFileSizeAllowed = this.props.template.maxFileSizeAllowed;
		const validateType = allowedFileTypes.length > 0 ? allowedFileTypes.includes(typeFile) : null;
		const sizeFile = selectedFile.size / 1024;
		const validateSize = sizeFile > maxFileSizeAllowed;

		DocumentActions.setSubmitDataField(this.props.id, fileFieldKey, selectedFile);
		DocumentActions.setDocumentFileSelected(this.props.id, selectedFile);

		if (validateType === false && maxFileSizeAllowed === null) {
			sessionStorage.removeItem('click');
			this.openModal('openImportDocumentModal');

			DocumentActions.displayFlashMessage(this.props.id, { type: 'error', message: Realize.i18n.t(`template.messages.allowedFileTypes`).replace('@@type@@', allowedFileTypes) });
		}
		else if (validateType === false && maxFileSizeAllowed !== null && validateSize === true) {
			sessionStorage.removeItem('click');
			this.openModal('openImportDocumentModal');

			DocumentActions.displayFlashMessage(this.props.id, { type: 'error', message: Realize.i18n.t(`template.messages.allowedFileTypesSize`).replace('@@type@@', allowedFileTypes).replace('##size##', maxFileSizeAllowed) });
		}
		else if ((validateType === null || validateType === true) && maxFileSizeAllowed !== null && validateSize === true) {
			sessionStorage.removeItem('click');
			this.openModal('openImportDocumentModal');

			DocumentActions.displayFlashMessage(this.props.id, { type: 'error', message: Realize.i18n.t(`template.messages.maxFileSizeAllowed`).replace('##size##', maxFileSizeAllowed) });
		}
		else if (Object.keys(this.props.template.fields).length) {
			sessionStorage.removeItem('click');
			this.openModal('openImportDocumentModal');

			DocumentActions.dismissFlashMessage(this.props.id);
		}
		else {
			$(`#container-import-file-input__${this.props.id} .drop-file-input`).addClass("hide");
			$(`#container-import-file-input__${this.props.id} .container-loader-import-file`).addClass("active");

			DocumentActions.dismissFlashMessage(this.props.id);
			DocumentActions.importDocument(this.props.id);
		}

		field.subscribe(FormEvents.DOCUMENT_IMPORT_SUCCESS, () => {
			$(`#container-import-file-input__${this.props.id} .container-loader-import-file`).removeClass("active");
			$(`#container-import-file-input__${this.props.id} .import-file-input`).val("");
		});

		field.subscribe(FormEvents.DOCUMENT_IMPORT_ERROR, () => {
			$(`#container-import-file-input__${this.props.id} .drop-file-input`).removeClass("hide");
			$(`#container-import-file-input__${this.props.id} .container-loader-import-file`).removeClass("active");
			$(`#container-import-file-input__${this.props.id} .import-file-input`).val("");
		});
	}

	renderButtonGroup() {
		const documentDisabled = this.props.disabled;
		const buttonGroupProps = this.props.selected
			? this.buildManageDocumentButtonGroupProps()
			: this.buildSelectDocumentButtonGroupProps();


		if (documentDisabled === true && !this.props.value) {
			return <ButtonGroup className={"document-action-buttons"}/>;
		}

		const btCertificate = buttonGroupProps.find(p => p && p.icon === 'certificate');

		return (
			<div className={buttonGroupProps.filter(bt => bt && bt.icon === 'certificate') ? 'certificate-digital' : ''}>
				<ButtonGroup className={"document-action-buttons"} buttons={buttonGroupProps.filter(bt => bt && bt.icon !== 'certificate')} />
				{btCertificate ?
					<a id="anchor-digital-signature" className="button btn waves-effect waves-light button--icon button-cancel black-text grey lighten-4 tooltipped" data-position="top" data-delay="10" data-tooltip={`${Realize.i18n.t('template.actions.digitalSignature')}`} onClick={btCertificate.onClick.bind(this)}>
						<svg className='icon-certificate-digital' xmlns="http://www.w3.org/2000/svg" fill="#000000" width="24" height="24" viewBox="0 0 24 24">
							<path d="M4,3C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H12V22L15,19L18,22V17H20A2,2 0 0,0 22,15V8L22,6V5A2,2 0 0,0 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z"/>
							<path d="M0 0h24v24H0z" fill="none"/>
						</svg>
					</a>
				: ''}
			</div>
		);
	}

	inputClassName() {
		const formApi = FormAPI.form(this.props.formId);
		let field = formApi.fields(this.props.id);
		let className = this.className();

		if (this.props.gridFormParent) {
			field = formApi.fields(this.props.gridFormParent).fields(this.props.id);
		}

		const errors = field.errors();

		if (!!errors && errors.length > 0) {
			className += ' ' + Realize.themes.getCssClass('input.error');
		}

		if (this.getLicenseEcm() === false) {
			className += ' input-license-basic';
		}

		return className;
	}

	nameFileDocument() {
		if (this.props.document?.fileName !== undefined && this.props.document?.fileName !== 'undefined.pdf') {
			return this.props.document.fileName;
		}

		if (this.props.document?.fileName !== undefined && this.props.document?.fileName === 'undefined.pdf') {
			const value = this.props.value;
			const valueSplit = value.split(':');

			return valueSplit[0];
		}

		return null;
	}

	renderDocumentNameInput() {
		return (
			<>
				<div className="document-field__name">
					<LecomLabel
						{...this.props}
						className={this.readOnlyDocumentLabel()}
						id={this.props.id}
						active={this.props.selected}
						key={`lecom--label__${this.props.id}`}
					/>
					<InputText
						id={`${this.props.id}`}
						className={this.readOnlyDocument() || this.disabledDocument() + `${this.inputClassName()} file-path${this.getClassName()}`}
						readOnly={true}
						value={this.nameFileDocument()}
						disabled={this.props.disabled}
						onClick={this.onClickDocumentNameInput}
						onKeyPress={(e) => {
							let idField = `input__${this.props.id}`;
							let classInput = 'file-path';

							if (this.props.selected) {
								$(`#${idField} .${classInput}`).focus();
								$(`#${idField} .${classInput}`)[0].click();
							}
						}}
					/>
				</div>

				{(!this.props.selected && !this.props.disabled && !this.props.readOnly && this.props.canImport && this.props.visible) &&
					<div id={`container-import-file-input__${this.props.id}`} className="container-import-file">
						<div className='drop-file-input'
							onClick={(e) => this.clickDropFileInput(e)}
							onMouseOver={(e) => this.dragOverFileInput(e)}
							onMouseOut={(e) => this.dragLeaveFileInput(e)}
							onDragEnter={(e) => this.dragEnterFileInput(e)}
							onDragOver={(e) => this.dragOverFileInput(e)}
							onDragLeave={(e) => this.dragLeaveFileInput(e)}
							onDrop={(e) => this.dropFileInput(e)}
						/>

						<input type="file" className="import-file-input" onChange={(e) => this.changeImportFileInput(e)} />
						<div className="container-loader-import-file"><span className='loader-import-file'></span> {Realize.i18n.t('importMultipleModal.importing')}</div>
					</div>
				}
			</>
		);
	}

	readOnlyDocumentLabel(){
		return this.props.readOnly ? 'labelReadOnlyDocument ' : '';
	}

	readOnlyDocument() {
		return this.props.readOnly ? 'readOnlyDocument ' : '';
	}

	disabledDocument() {
		return this.props.disabled ? 'disabledDocument ' : '';
	}

	render() {
		const readOnly = this.props.readOnly;

		return (
			<div className="document-field__wrapper">
				<div className="file-field document-field">
					{readOnly && this.renderButtonGroup()}

					<div className="file-path-wrapper">
						{this.renderDocumentNameInput()}
					</div>

					{!readOnly && this.renderButtonGroup()}
				</div>
			</div>
		);
	}
}
